import React, { useState } from 'react';
import { connect, useSelector } from 'react-redux';

import ZRMUtils from '@zg-rentals/zrm-utils-js/lib/utils';

import { RoutingSelectors } from 'app/shared/selectors';
import { withErrorBoundary } from 'app/shared/components/ErrorBoundary';

import PageWizard from 'app/shared/components/PageWizard';
import WizConvertListingInfo from 'app/shared/components/WizardListingClaim/WizConvertListingInfo';
import WizFindListingResults from 'app/shared/components/WizardListingClaim/WizFindListingResults';
import WizFindListingSuccess from 'app/shared/components/WizardListingClaim/WizFindListingSuccess';
import WizVerifyContactList from 'app/shared/components/WizardListingClaim/WizVerifyContactList';
import WizVerifyContactSuccess from 'app/shared/components/WizardListingClaim/WizVerifyContactSuccess';

import {
    DEEP_LINK_STEP,
    PROGRESS_STEP_CONFIG,
    PROGRESS_STEP,
    STEP,
} from './constants';

import {
    StyledContainer,
} from './StyledComponents';

const propTypes = {};
const defaultProps = {};

const ListingClaimPage = () => {
    const search = useSelector(state => RoutingSelectors.makeSearch(state));
    const paramStep = ZRMUtils.queryUtils.parse(search.toString()).step;
    const initialDeepLinkStep = DEEP_LINK_STEP[paramStep];
    const [currentStepKey, setCurrentStepKey] = useState(initialDeepLinkStep || STEP.FIND_LISTING_RESULTS);
    const config = [
        {
            stepKey: STEP.FIND_LISTING_RESULTS,
            wizardBodyTemplate: WizFindListingResults,
            progressStepKey: PROGRESS_STEP.FIND_LISTING,
        },
        {
            stepKey: STEP.FIND_LISTING_SUCCESS,
            wizardBodyTemplate: WizFindListingSuccess,
            progressStepKey: PROGRESS_STEP.FIND_LISTING,
        },
        {
            stepKey: STEP.VERIFY_CONTACT_LIST,
            wizardBodyTemplate: WizVerifyContactList,
            progressStepKey: PROGRESS_STEP.VERIFY_CONTACT,
        },
        {
            stepKey: STEP.VERIFY_CONTACT_SUCCESS,
            wizardBodyTemplate: WizVerifyContactSuccess,
            progressStepKey: PROGRESS_STEP.VERIFY_CONTACT,
        },
        {
            stepKey: STEP.CONVERT_LISTING_INFO,
            wizardBodyTemplate: WizConvertListingInfo,
            progressStepKey: PROGRESS_STEP.CONVERT_LISTING,
        },
    ];

    const handleGoToStep = (key) => {
        window.scroll(0, 0);
        setCurrentStepKey(key);
    };

    return (
        <StyledContainer>
            <PageWizard
                steps={config}
                progressSteps={PROGRESS_STEP_CONFIG}
                currentStepKey={currentStepKey}
                onGoToStep={handleGoToStep}
            />
        </StyledContainer>
    );
};

ListingClaimPage.propTypes = propTypes;
ListingClaimPage.defaultProps = defaultProps;

export { ListingClaimPage };
export default withErrorBoundary(connect()(ListingClaimPage));
